export const formatDate = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  const dd = String(d.getDate()).padStart(2, '0');
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  return `${dd} ${monthNames[d.getMonth()]}, ${d.getFullYear()}`;
};

export const formatINR = (value) => {
  if (value === null || value === undefined) return '₹ 0.00';
  return '₹ ' + Math.abs(value).toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 2 });
};

export const STATUS_STYLES = {
  Pending: { label: 'Pending', icon: '⏳', color: '#F57C00', bg: '#FFF3E0' },
  Approved: { label: 'Approved', icon: '✅', color: '#1a7a3c', bg: '#E8F5E9' },
  Rejected: { label: 'Rejected', icon: '❌', color: '#c62828', bg: '#FFEBEE' },
};

export const TXN_STYLES = {
  Investment: { icon: '➕', label: 'Investment', color: '#1a7a3c' },
  Verantage: { icon: '➖', label: 'Verantage', color: '#c62828' },
};

export const PAYMENT_CATEGORY_STYLES = {
  WorkerPayment: { icon: '👷', label: 'Worker Payment', color: '#8D6E63' },
  SupplierPayment: { icon: '🏭', label: 'Supplier Payment', color: '#1976D2' },
};

export const getCategoryIcon = (category) => {
  const map = {
    'Job Work': { icon: '🔨', color: '#5D4037' },
    'Raw Material': { icon: '📦', color: '#607D8B' },
    'Transportation': { icon: '🚚', color: '#1976D2' },
    'Stationary': { icon: '✏️', color: '#FB8C00' },
    'Ready Item Purchase': { icon: '🛍️', color: '#E91E63' },
    'Salary': { icon: '💰', color: '#4CAF50' },
    'Chrome': { icon: '⚗️', color: '#9C27B0' },
    'Furniture': { icon: '🪑', color: '#795548' },
    'Courier': { icon: '📮', color: '#FF9800' },
    'Maintainance': { icon: '🔧', color: '#F44336' },
    'Casting': { icon: '🔥', color: '#FF5722' },
    'Office Expense': { icon: '🏢', color: '#3F51B5' },
    'Packaging & parcel': { icon: '📦', color: '#8BC34A' },
    'Master Charge': { icon: '⭐', color: '#FFD600' },
    'Charges': { icon: '💳', color: '#2196F3' },
    'Tour': { icon: '✈️', color: '#03A9F4' },
    'Donation': { icon: '🤝', color: '#F06292' },
    'Tool for Work': { icon: '🛠️', color: '#455A64' },
    'Service Charge': { icon: '🛎️', color: '#009688' },
    'Refund': { icon: '↩️', color: '#673AB7' },
    'Tax': { icon: '%', color: '#FF5252' },
    'Software': { icon: '💻', color: '#00BCD4' },
    'Samples': { icon: '🧪', color: '#CDDC39' },
    'Gift Product': { icon: '🎁', color: '#FF4081' },
    'Loan': { icon: '🏦', color: '#7E57C2' },
  };
  return map[category || ''] || { icon: '💸', color: '#888' };
};
